<template>
  <div class="sgc-chips-wrap">
    <div class="sgc-chips-ctr">
      <v-chip
        v-for="(item, index) in props.modelValue"
        :key="index"
        class="autocmp-chip"
        size="small"
        :disabled="disabled"
        closable
        @click:close="removeOption(index)"
        >{{ item }}</v-chip
      >
    </div>
    <v-autocomplete
      :id="id"
      ref="input"
      v-model="tmp"
      v-model:searchInput="search"
      clearable
      hideDetails
      hideNoData
      autofocus
      variant="outlined"
      :disabled="disabled"
      persistentPlaceholder
      :placeholder="title"
      itemTitle="text"
      :label="help"
      bgColor="white"
      class="sgc-autocomplete-location"
      :menuProps="{ maxHeight: 410, offsetY: true, minWidth: 400 }"
    />
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref } from "vue";

const { uid } = getCurrentInstance();

const props = defineProps(["modelValue", "title", "help", "geoType", "hint", "disabled"]);
const emit = defineEmits(["update:modelValue"]);

const autocompleteComponent = ref(null);
const tmp = ref("");
const search = ref("");
const input = ref(null);
const id = `rf-google-autocomplete-${uid}`;

const removeOption = index =>
  emit(
    "update:modelValue",
    props.modelValue.filter((_, i) => i !== index),
  );

onMounted(() => {
  const input = document.querySelector(`#${id}`);
  autocompleteComponent.value = new window.google.maps.places.Autocomplete(input, {
    types: [`(${props.geoType})`],
  });
  autocompleteComponent.value.addListener("place_changed", () => {
    const place = autocompleteComponent.value.getPlace();
    if (place.place_id) {
      const newValues = Array.from(new Set([...props.modelValue, place.name]));
      search.value = "";
      emit("update:modelValue", newValues);
      input.focus();
    }
    tmp.value = "";
  });
});
</script>
